module.exports = __webpack_public_path__ + "static/furniture-now-logo-15d0ea4d35995c21d9633ffa7fed4803.jpg";